import React from 'react';
import { useFavourites } from '../favourites/FavouritesContext';
import { useLocale } from '../i18n/LocaleContext';
import { HeartIcon } from './Icons';

export default function FavouriteButton({ event, variant = 'overlay', size = 18 }) {
  const { isFavourite, toggle } = useFavourites();
  const { t } = useLocale();
  const saved = isFavourite(event._id);
  const label = t(saved ? 'favourites.remove' : 'favourites.add');

  return (
    <button
      type="button"
      className={`fav fav--${variant}${saved ? ' fav--on' : ''}`}
      // The card itself is a button; without this the click would also navigate.
      onClick={(clickEvent) => {
        clickEvent.stopPropagation();
        clickEvent.preventDefault();
        toggle(event);
      }}
      aria-pressed={saved}
      aria-label={label}
      title={label}
    >
      <HeartIcon size={size} filled={saved} />
      {variant === 'inline' && <span>{t('favourites.title')}</span>}
    </button>
  );
}
